// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ay43","delete":"styles_delete__3KnX-","update":"styles_update__15tZE","add":"styles_add__2nYf7"};